import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import * as sdkclaro from '@claro/sdkclaromicrofront';
import "./index.css";
import AppMain from "./AppMain";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./store";
import { 
  SERVICE_ID_TELCEL_POSPAGO, 
  SERVICE_ID_TELCEL_PLANES,
  CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE,
  BUNDLE_ID_CONTAINER_TELCEL,
  SERVICE_ID_TELCEL_PAQUETES_POSPAGO,
  CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS
} from './constants';
import { useClaropaySdk } from "./services/sdk/SDKServiceWeb.tsx";

const history = createBrowserHistory();
const store = configureStore(history);

sdkclaro.getInstance(
  "XXXXXXX", 
  (apiKeySource, token, profileInformation, resourceInformation)=>{console.log('onLaunch')}, 
  (eventName, eventInformation)=>{console.log('onShow')}, 
  ()=>{console.log('onHide')}, 
  ()=>{console.log('onError')}, 
  (eventName,eventInformation)=>{
    console.log(eventName, 'eventName')
    console.log(eventInformation, 'eventInformation')
    if (eventName==='loggued_in_response') {
      store.dispatch({
        type: "SET_RELOAD_INFO_AFTER_ADDING_CARD",
        payload: true
      });
    }
    if(eventName==='_ONBACK_'){
      window.history.back();
    } 
    if(eventName === 'ON_DOBLE_BACK'){
      const {
        serviceId, 
        categoryPlansId, 
        paramsNewOfferTelcel
      } = JSON.parse(localStorage.getItem("microappInfo"));
      if(
        (paramsNewOfferTelcel && 
        (
          serviceId === SERVICE_ID_TELCEL_PAQUETES_POSPAGO &&
          categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS
        ) ||
        (
          serviceId === SERVICE_ID_TELCEL_PLANES &&
          categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE
        )) || 
        (paramsNewOfferTelcel && serviceId == SERVICE_ID_TELCEL_POSPAGO)
      ){
        setTimeout(() => {
          window.history.back();
        }, 1000);
      }
    }
    if(eventName === 'refreshCards'){
      store.dispatch({
        type: "SET_PAYMENT_METHOD",
        payload: eventInformation
      });
    }
    if (eventName === "nip_response") {
      const eventInformationObject = JSON.parse(eventInformation);
      const { encodedPin } = eventInformationObject;
      store.dispatch({
        type: "DOMICILIATION_REFERENCE",
        encodedPin: encodedPin
      });
    }
    if (eventName === "date_picker_response") {
      const eventInformationObject = JSON.parse(eventInformation);
      const { selectedDate } = eventInformationObject;
      store.dispatch({
        type: "SET_DATE_FROM_NATIVE_DATE_PICKER",
        payload: selectedDate,
      });
    }
  }, 
  {}
)

// Initialize SDK Web (Using for add card - Anonimous user)
useClaropaySdk().initialize();

const urlParam = new URLSearchParams(window.location.search);
const activeN2QueryParam = urlParam.get("activeN2");
const hasCreditQueryParam = urlParam.get("hasCredit");
const flags = urlParam.get("flags");
const lineNumber = urlParam.get("accountServiceProvider"); // use this 
const originOfPayment = urlParam.get("originOfPayment");
const bundleVersion = urlParam.get("bundleVersion");
const bundleId = urlParam.get("bundleId");
const parameters = urlParam.get("params");
const paymentAmountFromUrl = urlParam.get("paymentAmount");
const productIdFromUrl = urlParam.get("productId");
const isTemporalClaroId = urlParam.get("isTemporalClaroId");
const goToDomiciliationForm = urlParam.get("goToDomiciliationForm");
const goToMicroappAdelanto = urlParam.get("goToMicroappAdelanto");

store.dispatch({
  type: "SET_IS_TEMPORAL_CLARO_ID",
  payload: isTemporalClaroId === "true" ? true : false,
});

store.dispatch({
  type: "SET_IS_ANONIMOUS",
  payload: isTemporalClaroId === "true" ? true : false,
});

let params = null;

try {
  params = atob(parameters)
  params = JSON.parse(params)
} catch {
  params = null;
}

store.dispatch({
  type: "SET_IS_CONTAINER_TELCEL",
  payload: BUNDLE_ID_CONTAINER_TELCEL.includes(bundleId) ? true : false
})

store.dispatch({
  type: "GET_PARAMS_FROM_URL",
  params: params,
});

store.dispatch({
  type: "GET_BUNDLE_VERSION_FROM_URL",
  bundleVersion: bundleVersion ? bundleVersion : 0,
});

store.dispatch({
  type: "GET_BUNDLE_ID_FROM_URL",
  bundleId: bundleId ? bundleId : false,
});

store.dispatch({
  type: "GET_PHONE_NUMBER",
  lineNumber: lineNumber,
});

store.dispatch({
  type: "ORIGIN_OF_PAYMENT",
  originOfPayment: originOfPayment,
});

let activeN2Value =
  activeN2QueryParam === "true" || activeN2QueryParam === null ? true : false;
store.dispatch({
  type: "GET_ACTIVE_FROM_URL",
  activeN2: activeN2Value,
});

let canEncryptValue = flags && flags.includes("CAN_ENCRYPT") ? true : false;
store.dispatch({
  type: "GET_CAN_ENCRYPT",
  canEncrypt: canEncryptValue,
});

let canManageFavorites = flags && flags.includes("CAN_MANAGE_FAVORITES") ? true : false;
store.dispatch({
  type: "GET_CAN_MANAGE_FAVORITES",
  canManageFavorites: canManageFavorites,
});

let canFavoriteTooltip = flags && flags.includes("CAN_FAVORITE_TOOLTIP") ? true : false;
store.dispatch({
  type: "GET_CAN_FAVORITE_TOOLTIP",
  canFavoriteTooltip: canFavoriteTooltip,
});

let sendServiceIdValue =
  flags && flags.includes("SEND_SERVICEID") ? true : false;
store.dispatch({
  type: "SEND_SERVICEID",
  canSendServiceId: sendServiceIdValue,
});

let hasCreditValue = hasCreditQueryParam === "true" ? true : false;
store.dispatch({
  type: "GET_HAS_CREDIT_FROM_URL",
  hasCredit: hasCreditValue,
});

const sendClaroSocioValue = flags && flags.includes("SEND_ISCLAROSOCIO") ? true : false;
store.dispatch({
  type: "SEND_ISCLAROSOCIO",
  canSendClaroSocioValue: sendClaroSocioValue,
});

const showCanCookies = flags && flags.includes("CAN_COOKIES") ? true : false;
store.dispatch({
  type: "SHOW_CAN_COOKIES",
  canShowCanCookies: showCanCookies,
});

const showNewOfferTelcel = flags && flags.includes("SHOW_NEW_OFFER_TELCEL") ? true : false;
store.dispatch({
  type: "SHOW_NEW_OFFER_TELCEL",
  canShowNewOfferTelcel: showNewOfferTelcel,
});

store.dispatch({
  type: "GET_PAYMENT_AMOUNT_FROM_URL",
  payload: paymentAmountFromUrl,
});

store.dispatch({
  type: "GET_PRODUCT_ID_FROM_URL",
  payload: productIdFromUrl,
});

store.dispatch({
  type: "CAN_CALL_NIP",
  canCallNip: !!flags && flags.includes("CAN_CALL_NIP"),
});

store.dispatch({
  type: "SET_GO_TO_DOMICILIATION_FORM",
  payload: goToDomiciliationForm === "true",
});

store.dispatch({
  type:"GET_GO_TO_MICROAPPADELANTO",
  payload: goToMicroappAdelanto
})

ReactDOM.render(
  <AppMain store={store} history={history} />,
  document.getElementById("root")
);

serviceWorker.unregister();

